export default __webpack_public_path__ + "static/media/pic10.6f693fb3.jpg";